export enum OperationCreationMode {
  MANUAL = "MANUAL",
  AUTOMATIC = "AUTOMATIC",
}
